<div class="footer stretch">
    <span>QR Money Solutions Administrative Panel</span>
    <span>QR Money Solutions &copy; {{year}}. All rights reserved.</span>
</div>
